import React from 'react';
import { cn } from '../../lib/cn';

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  compact = false,
  className
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'py-8' : 'py-14',
        className
      )}
    >
      {Icon ? (
        <div className="h-11 w-11 rounded-full bg-slate-100 text-slate-400 flex items-center justify-center mb-3">
          <Icon className="h-5 w-5" />
        </div>
      ) : null}
      {title ? (
        <p className="text-[14px] font-semibold text-slate-700">{title}</p>
      ) : null}
      {description ? (
        <p className="text-[13px] text-slate-500 mt-1 max-w-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
